<template>
  <div>
      <span :style="`font-size: ${size}rem;`" :class="`text-${variant}`">{{ time }}</span>
  </div>
</template>

<script>
export default {
    props: {
        size: {
            type: [String, Number],
            default: 1
        },
        variant: {
            type: String,
            default: 'primary'
        }
    },
    data: () => ({
        time: '',
        timeInterval: null
    }),
    methods: {
        start() {
            this.time = moment().format('HH:mm:ss')
            this.timeInterval = setInterval(() => {
                this.time = moment().format('HH:mm:ss')
            }, 1000);
        }
    },
    created() {
        this.start()
    },
    beforeDestroy() {
        clearInterval(this.timeInterval)
    }
}
</script>

<style>

</style>
